import TrainingCard from './TrainingCard';

export default TrainingCard;
